import { useState, type FormEvent } from "react";
import { useCompositionStore } from "../../stores/compositionStore.js";
import { Button } from "../../ui/Button.js";

export function CommandBar(): JSX.Element {
  const [text, setText] = useState("");
  const status = useCompositionStore((s) => s.commandBar.status);
  const error = useCompositionStore((s) => s.commandBar.error);

  function handleSubmit(e: FormEvent): void {
    e.preventDefault();
    if (!text.trim() || status === "running") return;
    void (async () => {
      try {
        await useCompositionStore.getState().runCommand(text);
        setText("");
      } catch {
        // store has recorded the error
      }
    })();
  }

  return (
    <form onSubmit={handleSubmit} className="flex gap-2" aria-label="Command bar">
      <input
        type="text"
        className="flex-1 rounded bg-bg-card px-3 py-1.5 text-sm text-ink outline-none"
        placeholder="Type a command..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        aria-label="Command text"
        disabled={status === "running"}
      />
      <Button type="submit" disabled={status === "running" || !text.trim()}>
        {status === "running" ? "..." : "Run"}
      </Button>
      {status === "error" && error ? (
        <span role="alert" className="self-center text-xs text-accent-danger">
          {error}
        </span>
      ) : null}
    </form>
  );
}
